import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, notification } from 'antd';
import { useTranslation } from 'react-i18next';

import Context from '../../context';
import ModalWrapper from '../ModalWrapper';
import RegistrationForm from '../RegistrationForm';

import './index.less';

const NewMarketParty = ({ onClose }) => {
  const { updateMarketParties } = useContext(Context);
  const { t } = useTranslation();

  const handleCreated = () => {
    notification.success({
      message: `${t('marketParty.title.marketParty')} ${t('common.status.successfullyCreated')}`,
      description: '',
    });
    updateMarketParties();
    onClose();
  };

  return (
    <ModalWrapper
      modalClassName="new-marketparty__modal"
      title={t('marketParty.title.newMarketParty')}
      handleClose={onClose}
      actionButtons={[
        <Button key="cancel" onClick={onClose}>
          {t('common.button.cancel')}
        </Button>,
      ]}
      width="62rem"
    >
      <RegistrationForm isRegistrationSuccesful={handleCreated} />
    </ModalWrapper>
  );
};

NewMarketParty.displayName = 'NewMarketParty';
NewMarketParty.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default NewMarketParty;
